import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export interface SenecLoadingOverlayProps {
    "data-testid"?: string;
    isVisible: boolean;
    blur?: boolean;
    zIndex?: number;
}

export const SenecLoadingOverlay = ({
    "data-testid": dataTestId = "loading",
    isVisible,
    blur = true,
    zIndex = 1,
}: SenecLoadingOverlayProps) => {
    if (!isVisible) return null;

    return (
        <Box
            position="absolute"
            display="flex"
            justifyContent="center"
            alignItems="center"
            top={0}
            left={0}
            right={0}
            bottom={0}
            sx={{
                backdropFilter: blur ? "blur(1px)" : "none",
                zIndex: zIndex,
            }}
        >
            <CircularProgress data-testid={dataTestId} />
        </Box>
    );
};
